import { render, staticRenderFns } from "./WorkCoverView.vue?vue&type=template&id=dbb20294&scoped=true"
import script from "./WorkCoverView.vue?vue&type=script&lang=js"
export * from "./WorkCoverView.vue?vue&type=script&lang=js"
import style0 from "./WorkCoverView.vue?vue&type=style&index=0&id=dbb20294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb20294",
  null
  
)

export default component.exports